export const teachTrain = [
  {
    path: '/teachTrainList',
    name: 'teachTrainList',
    component: () => import('views/teachTrain/teachTrainList/index'),
    meta: {
      title: '付呗收款单',
      keepAlive: false
    }
  },
  {
    path: '/teachTrainList/exportRecordSet',
    name: 'exportRecord',
    component: () => import('views/teachTrain/teachTrainList/exportRecordSet/index'),
    meta: {
      title: '导出记录'
    }
  },
  {
    path: '/teachTrainList/exportRecord/selectStore',
    name: 'trainSelectStore',
    component: () => import('views/teachTrain/teachTrainList/selectStore/index'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/teachTrainList/exportRecord/searchExportReceipt',
    name: 'searchExportReceipt',
    component: () => import('views/teachTrain/teachTrainList/searchExportReceipt/index'),
    meta: {
      title: '选择导出'
    }
  },
  {
    path: '/teachTrainList/createList',
    name: 'teachTrainCreateList',
    component: () => import('views/teachTrain/teachTrainList/createList/index'),
    meta: {
      title: '新建收款单'
    }
  },
  {
    path: '/teachTrainList/detail',
    name: 'teachTrainDetail',
    component: () => import('views/teachTrain/teachTrainDetail/index'),
    meta: {
      title: '收款单详情',
      keepAlive: true
    }
  },
  {
    path: '/teachTrainList/detail/orderDetail',
    name: 'teachTrainOrderDetail',
    component: () => import('views/teachTrain/teachTrainDetail/orderDetail/index'),
    meta: {
      title: '收款单订单详情'
    }
  }
]
